import type { JsonifiedClient } from "@orpc/openapi-client";
import type { ContractRouterClient } from "@orpc/contract";
import { createORPCClient } from "@orpc/client";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import {
  authContract,
  jobRoleContract,
  locationContract,
  scheduleContract,
} from "@hourly/api-client";

const HOURLY_API_URL = import.meta.env.VITE_HOURLY_API_URL ?? "";

// Token getter — wired by AuthContext via registerHourlyTokenGetter()
let _getHourlyToken: () => string | null = () => null;

export function registerHourlyTokenGetter(fn: () => string | null): void {
  _getHourlyToken = fn;
}

// Authenticated link (for job-roles, locations, schedule)
const authLinkOptions = {
  url: `${HOURLY_API_URL}/orpc`,
  headers: () => {
    const token = _getHourlyToken();
    return token ? { authorization: `Bearer ${token}` } : {};
  },
};

// Public link (for login, refresh — no Bearer token)
const publicLinkOptions = {
  url: `${HOURLY_API_URL}/orpc`,
};

// Public auth client (login, refresh)
const authPublicLink = new OpenAPILink(authContract, publicLinkOptions);
export const hourlyAuthClient: JsonifiedClient<ContractRouterClient<typeof authContract>> =
  createORPCClient(authPublicLink);

// Authenticated domain clients
const jobRoleLink = new OpenAPILink(jobRoleContract, authLinkOptions);
const jobRoleClient: JsonifiedClient<ContractRouterClient<typeof jobRoleContract>> =
  createORPCClient(jobRoleLink);

const locationLink = new OpenAPILink(locationContract, authLinkOptions);
const locationClient: JsonifiedClient<ContractRouterClient<typeof locationContract>> =
  createORPCClient(locationLink);

const scheduleLink = new OpenAPILink(scheduleContract, authLinkOptions);
const scheduleClient: JsonifiedClient<ContractRouterClient<typeof scheduleContract>> =
  createORPCClient(scheduleLink);

export const hourlyClient = {
  authPublic: hourlyAuthClient,
  jobRole: jobRoleClient,
  location: locationClient,
  schedule: scheduleClient,
};
